import Avatar from './avatar';
import Group from './group';
export * from './interface';
var AvatarComponent = Avatar;
AvatarComponent.Group = Group;
export default AvatarComponent;
